import { AvailableTournamentDataMapper } from 'modules/auth/domain/data-mappers/available-tournament.data-mapper';
import { AvailableTournamentDto } from 'modules/auth/domain/dtos/available-tournament.dto';
import { AuthAvailableTournament } from 'modules/auth/domain/interfaces/auth-available-tournament';
import { restApi } from 'shared/api/rest-api';

export interface ListAvailableTournamentsArgs {
  limit: number;
  offset: number;
  namePart?: string;
}

const availableTournamentsApi = restApi.injectEndpoints({
  endpoints: (build) => ({
    listAvailableTournaments: build.query<AuthAvailableTournament[], ListAvailableTournamentsArgs>({
      query: ({ limit, offset, namePart }) => ({
        url: '/tournaments',
        method: 'GET',
        params: { limit, offset, ...(namePart ? { namePart } : {}) },
      }),
      transformResponse: (raw: AvailableTournamentDto[]): AuthAvailableTournament[] => {
        const mapper = new AvailableTournamentDataMapper();
        return (raw ?? []).map((dto) => mapper.decode(dto));
      },
      providesTags: (result) =>
        result && result.length
          ? [
              ...result.map((tournament) => ({ type: 'Tournament' as const, id: tournament.id })),
              { type: 'Tournament' as const, id: 'PARTIAL-LIST' },
            ]
          : [{ type: 'Tournament' as const, id: 'PARTIAL-LIST' }],
      keepUnusedDataFor: 60,
    }),
  }),
  overrideExisting: false,
});

export const { useListAvailableTournamentsQuery } = availableTournamentsApi;

export default availableTournamentsApi;
